import { render } from "./PageCreateClass.vue?vue&type=template&id=44400f5f"
import script from "./PageCreateClass.vue?vue&type=script&lang=js"
export * from "./PageCreateClass.vue?vue&type=script&lang=js"

import exportComponent from "/Users/shenshenmac/codes/fan_mei/fanmei_v3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__